export default {
  coin: {
    43114: '0x0400430187A84f114131a865e3f3d9F1ABa1093D',
  },
  coinPresale: {
    43114: '0xd2103234717E7cE897730E8251983983bB749Ef3',
  },
  coinusdt: {
    43114: '0x5FC8d32690cc91D4c39d9d3abcBD16989F875707',
  },
  usdt: {
    43114: '0xc7198437980c041c805A1EDcbA50c1Ce5db95118',
  },
  masterChef: {
    43114: '0x3f9C3eB86d6c8fB7d9dfb724583ec0134F08F8c6',
  },
  multiCall: {
    43114: '0x594052B0A068Ec1F242dD71872cc69fEcB8F6840',
  },

  cake: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954', // XXXXCAKE
  },
  timelock: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954', // XXXXSOUS
  },
  liqLocker: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954', // XXXXSOUS
  },
  rugdoc: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  chess: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954', // XXXXCHESS
  },
  lottery: {
    56: '',
    97: '',
  },
  lotteryNFT: {
    56: '',
    97: '',
  },

  romefos: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  tokyofos: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  denverfos: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  swapromefos: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  swaptokyofos: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  swapdenverfos: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },

  corn: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954', // XXXXCORN
  },
  tmt: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954', // XXXXTMT
  },
  usdc: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  wavax: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  avax: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  weth: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  wbtc: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  joe: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  dai: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },

  cakewavax: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954', // XXXXONIONWAVAX
  },
  cakeusdc: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954', // XXXXONIONUSDC
  },
  cakeusdt: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954', // XXXXONIONUSDT
  },
  cakeweth: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954', // XXXXONIONWETH
  },
  cakewbtc: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954', // XXXXONIONWBTC
  },
  cakedai: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954', // XXXXONIONDAI
  },
  cakejoe: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954', // XXXXONIONJOE
  },
  caketmt: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954', // XXXXONIONTMT
  },
  cakecorn: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954', // XXXXONIONCORN
  },

  usdcusdt: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  wavaxusdt: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  wavaxusdc: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  wavaxweth: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  wethusdc: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  wbtcusdc: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  joeusdc: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  daiusdc: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  tmtusdt: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  tmtwavax: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
  cornusdc: {
    43114: '0x6523B9878b7857f42EB2F3c2D4824F078ff4e954',
  },
}
